<template>
  <layout-content>
    <tabs type="card" :animated="false" :value="$route.name" @on-click="set_tab">
      <tab-pane
        v-for="tab in tabs"
        :key="tab"
        :name="`integrations.tabs.${tab}`"
        :label="get_name_tab(tab)"
      />
    </tabs>
    <router-view />
  </layout-content>
</template>

<script>
  import { AmoService } from '@amo-widget/services/AmoService';
  export default {
    data: () => ({
      auth_data: [],
      tabs: ['auth', 'cases', 'users', 'numbers']
    }),
    async mounted() {
      this.auth_data = await AmoService.isAuth();
      if (this.auth_data.status === 'disconnected') {
        this.$router.push({ name: 'integrations.dashboard' }).catch(()=>{});
      }
    },
    methods: {
      set_tab: function (name) {
        this.$router.push({
          name: name
        });
      },
      get_name_tab(name) {
        return this.$t(`integrations.tabs.${name}`);
      }
    }
  };
</script>
